import dayjs from 'dayjs';

export const getFileNameFromPath = (path: string): string => {
  return path.split('/').pop() || '';
};

export const truncateLast = (str: string, keep: number = 40) => {
  return str.length > keep ? "..." + str.slice(-keep) : str;
}

export const calculateDaysLeft = (date: dayjs.Dayjs | string): number => {
  const futureDate = dayjs(date);
  const today = dayjs();
  return futureDate.diff(today, 'days');
};

export const truncateLetters = (str: string | null, limit: number) => {
  if (str === null || str === undefined) return "";
  return str.length > limit ? str.substring(0, limit) + "..." : str;
}